import type { ChangeEventHandler } from "react";
import useTranslator from "../../hooks/useTranslator";

interface InputFieldProps {
  name: string;
  value: string;
  label: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  isHalf?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onBeforeInput?: (event: React.FormEvent<HTMLInputElement>) => void;
}

const InputField = ({
  name,
  value,
  label,
  onChange,
  onKeyDown,
  onBeforeInput,
}: InputFieldProps) => {
  const { _t } = useTranslator();
  return (
    <div className="main-form-group">
      <div className="form-group">
        <label>{_t(label)}</label>
        <input
          type="text"
          name={name}
          placeholder={_t(`enter${label}`, "Text used in onboarding process")}
          value={value}
          onChange={onChange}
          required
          {...(onKeyDown && { onKeyDown })}
          {...(onBeforeInput && { onBeforeInput })}
        />
      </div>
    </div>
  );
};

export default InputField;
